import { mapDenoiserLevelFromSysApi } from '@shure/shared/angular/data-access/system-api/mappers';

import { DenoiserChannel } from '../../api';
import { DenoiserChannelFragment } from '../graphql/generated/denoiser.generated';

export function mapDenoiserChannelFromSysApi(channel: DenoiserChannelFragment): DenoiserChannel {
	const {
		id,
		features,
		description: { constraints }
	} = channel;
	return {
		id,
		name: channel.features.name?.name,
		features: {
			denoiser: {
				enabled: features.denoiser?.enabled || false,
				level: mapDenoiserLevelFromSysApi(features.denoiser?.level)
			},
			channelConfiguration: channel.description.features.channelConfiguration.supported
				? {
						enabled: channel.features.channelConfiguration?.enabled || false,
						isMissing: channel.features.channelConfiguration === null
				  }
				: undefined
		},
		constraints: {
			denoiser: {
				supportedLevels:
					constraints.denoiser?.level?.options?.map((level) => mapDenoiserLevelFromSysApi(level)) || []
			}
		}
	};
}
